import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SimpleAlert } from "../components/Alerts/Alerts";
import { useTranslationApp } from "../lib/i18next";
import {
  OK,
  EMAIL_UNSUBSCRIBE_SUCCESS_TITLE,
  EMAIL_UNSUBSCRIBE_SUCCESS_TEXT,
  EMAIL_UNSUBSCRIBE_ERROR_TITLE,
  EMAIL_UNSUBSCRIBE_ERROR_TEXT,
} from "../i18n/keysTranslations";

const getEmailUnsubscribeAlertType = (search) => {
  const params = new URLSearchParams(search);
  const emailUnsubscribed = params.get("emailUnsubscribed");
  const emailUnsubscribeError = params.get("emailUnsubscribeError");

  if (emailUnsubscribed === "1") {
    return "success";
  }

  if (emailUnsubscribed === "0" || emailUnsubscribeError === "1") {
    return "error";
  }

  return null;
};

const stripEmailUnsubscribeParams = (search) => {
  const params = new URLSearchParams(search);
  params.delete("emailUnsubscribed");
  params.delete("emailUnsubscribeError");
  const next = params.toString();
  return next ? `?${next}` : "";
};

export const useEmailUnsubscribeQueryAlert = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslationApp();
  const lastHandledSearchRef = useRef("");

  useEffect(() => {
    const alertType = getEmailUnsubscribeAlertType(location.search);
    if (!alertType) return;

    if (lastHandledSearchRef.current === location.search) return;
    lastHandledSearchRef.current = location.search;

    const isSuccess = alertType === "success";

    SimpleAlert({
      title: t(
        isSuccess
          ? EMAIL_UNSUBSCRIBE_SUCCESS_TITLE
          : EMAIL_UNSUBSCRIBE_ERROR_TITLE
      ),
      text: t(
        isSuccess
          ? EMAIL_UNSUBSCRIBE_SUCCESS_TEXT
          : EMAIL_UNSUBSCRIBE_ERROR_TEXT
      ),
      icon: isSuccess ? "success" : "error",
      confirmButtonText: t(OK),
    });

    const nextSearch = stripEmailUnsubscribeParams(location.search);
    if (nextSearch !== location.search) {
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch,
        },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, navigate, t]);
};
